"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.FEATURE_FLAGS = void 0;
exports.FEATURE_FLAGS = [
    'AI_VACCINATION_DOCUMENTS',
    'BILLING_INVOICES',
    'EXPIRATION_GRACE_PERIOD',
    'HELP_SUPPORT_PAGE',
    'I9_FORM_ENABLED',
    'ON_CALL_SHIFTS',
    'ORIENTATION_OPPORTUNITIES',
    'PAY_HISTORY',
    'RATE_CALCULATOR',
    'WORK_QUALIFICATION_MODAL_TEST',
];
//# sourceMappingURL=feature-flags.js.map